'use client';
import {ReactNode} from "react";
import {HeroUIProvider} from "@heroui/react";
import {useRouter} from "next/navigation";
import {SessionProvider} from "next-auth/react";

export default function Providers({children}: { children: ReactNode }) {
    const router = useRouter();

    return (
        <SessionProvider basePath="/api/nextapi/auth">
            <HeroUIProvider navigate={router.push}>
                {children}
            </HeroUIProvider>
        </SessionProvider>
    );
}
